var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.decryptShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "decrypt" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\r\n            " +
                _vm._s(_vm.$t("language.common.decrypt")) +
                "\r\n            "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.decryptShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "decrypt-content" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.popup.personalCenter.pleaseSwitch"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "decrypt-footer" }, [
            _c(
              "button",
              {
                staticClass: "decrypt-button",
                staticStyle: { float: "right" },
                on: { click: _vm.switchOldVersion }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("language.popup.personalCenter.switchOld"))
                )
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f85b241", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f85b241","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/decrypt_popup.vue
// module id = null
// module chunks = 